<!--
  Side view of the Provisionsmatrix (cp.ProvisionTypeMatrix). Compact shape after
  cp-provision-contract-agent-side.component.html: one shared component, in its narrow variant.

  `w-full` and nothing else on the wrapper — the drawer owns the width, and the overflow container
  that keeps a wide table inside it sits on the table itself, in the overview component.
-->
@if (initialized && dto) {

    <div class="cp-provision-type-matrix-side w-full mt-3">

        <cp-provision-type-matrix-overview
                [provisionTypeMatrixId]="objectIdentifier.objectId"
                [compact]="true">
        </cp-provision-type-matrix-overview>

    </div>

}
